<script>
export default {
    methods: {
        is(role_label) {
            return this.$store.getters.is(role_label);
        },
        isFaculty() {
            return this.$store.getters.isFaculty || this.$store.getters.isGroupLeader;
        },
        isStudent() {
            return this.$store.getters.isStudent;
        },
        isGroupLeader() {
            return this.$store.getters.isGroupLeader;
        },
    }
}
</script>